// permissions[] of a vendor's manager or user: the modules and actions the account may use. The server enforces this on every API (see
// server/config/permissions.js, which holds the same vocabulary); here it only decides what the navigation and the pages offer.
//   "*"                 every module            "<module>:*"      read and write
//   "<module>:write"    write (includes read)    "<module>:read"   read
// Nothing is granted by default. A vendor admin is not limited by grants.
import { ROLES } from "./roles";

export const MODULES = [
  ["dashboard", "Dashboard"], ["leads", "Leads"], ["repairs", "Repairs"], ["services", "Services"], ["products", "Products"],
  ["inventory", "Inventory"], ["orders", "Orders"], ["whatsapp", "WhatsApp"], ["whatsappTemplates", "WhatsApp Templates"],
  ["emailSettings", "Email Settings"], ["deviceMasters", "Device Masters"], ["paymentAccounts", "Payment Accounts"], ["webhooks", "Webhooks"],
  ["auditLog", "Audit Log"], ["metaIntegration", "Meta Integration"], ["hero", "Hero"], ["popups", "Popups"], ["reviews", "Reviews"],
  ["billing", "Billing"], ["estimates", "Estimates"], ["payments", "Payments"], ["purchases", "Purchases"], ["creditNotes", "Credit / Debit Notes"],
  ["recurringInvoices", "Recurring Invoices"], ["reports", "Reports"], ["warranty", "Warranty"], ["users", "Users"], ["customers", "Customers"],
];

export const LEVELS = [["", "No access"], ["read", "View"], ["write", "View and change"]];

// The level a list of grants gives for one module: "", "read" or "write".
export function levelFor(permissions, moduleKey) {
  const grants = Array.isArray(permissions) ? permissions : [];
  if (grants.includes("*") || grants.includes(`${moduleKey}:*`) || grants.includes(`${moduleKey}:write`)) return "write";
  return grants.includes(`${moduleKey}:read`) ? "read" : "";
}

// grants for a module -> a new list of grants with that module set to `level` (other modules, and any "*", are kept as they are)
export function withLevel(permissions, moduleKey, level) {
  const rest = (Array.isArray(permissions) ? permissions : []).filter((grant) => !String(grant).startsWith(`${moduleKey}:`));
  return level ? [...rest, `${moduleKey}:${level === "write" ? "*" : "read"}`] : rest;
}

// May this signed-in account use a module? A vendor admin works in its vendor's modules; a manager or user needs a grant.
export function canUseModule(user, moduleKey, action = "read") {
  if (!user || user.scope === "platform" || user.scope === "invalid") return false;
  if (user.role === ROLES.ADMIN) return true;
  const level = levelFor(user.permissions, moduleKey);
  return action === "read" ? Boolean(level) : level === "write";
}
